import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectChecklistTypeDisplayTextPipe } from '@portal-core/project-checklists/pipes/project-checklist-type-display-text/project-checklist-type-display-text.pipe';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ProjectChecklistTypeDisplayTextPipe
  ],
  exports: [
    ProjectChecklistTypeDisplayTextPipe
  ]
})
export class ProjectChecklistTypeDisplayTextModule { }
